import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';

export default TimerOutlinedIcon;
